const leftContainer = document.querySelector(
  ".splitview-image-product-container-left"
);
const rightContainer = document.querySelector(
  ".splitview-image-product-container-right"
);
const containerParallex = document.querySelector(
  ".split-view-grid-image-container"
);

let aboveSection;

if (containerParallex) {
  const containerParallexParent = containerParallex.parentElement;
  const containerParallexGrandparent = containerParallexParent.parentElement;
  const containerParallexMainParent = containerParallexGrandparent.parentElement;

  aboveSection = containerParallexMainParent.previousElementSibling;
}

// Initial positions
if (leftContainer) {
  leftContainer.style.transform = "translateX(-100%)";
}
if (rightContainer) {
  rightContainer.style.transform = "translateX(100%)";
}

// Listen for the scroll event
window.addEventListener("scroll", function () {
  if(!aboveSection) return;
  // Calculate the scroll percentage
  const scrollPercent =
    (window.scrollY - (aboveSection.getBoundingClientRect().top + window.scrollY)) / (document.body.scrollHeight - window.innerHeight);

  let speed = 700;

  // Calculate the new positions
  const leftPosition = Math.min(0, scrollPercent * speed - 100);
  const rightPosition = Math.max(0, 100 - scrollPercent * speed);

  // Apply the new positions
  if (leftContainer) {
    leftContainer.style.transform = `translateX(${leftPosition}%)`;
  }
  if (rightContainer) {
    rightContainer.style.transform = `translateX(${rightPosition}%)`;
  }
});

function addClassWhenVisible(selector, className) {
  const elements = document.querySelectorAll(selector);
  elements.forEach((element) => {
    const rect = element.getBoundingClientRect();
    const isVisible = rect.top < window.innerHeight && rect.bottom >= 0;
    if (isVisible) {
      element.classList.add(className);
    }
  });
}

function initiateClassWhenVisbleFunctions() {
  addClassWhenVisible("[fade-in-scroll]", "fade-in-scroll");
  addClassWhenVisible("[fade-in-slide-left]", "fade-in-slide-left");
  addClassWhenVisible("[fade-in-rubber-scroll]", "fade-in-rubber-scroll");
  addClassWhenVisible("[fade-in-slide-bottom]", "fade-in-slide-bottom");
  addClassWhenVisible("[rubber]", "rubber");
  addClassWhenVisible("[spin]", "spin");
  addClassWhenVisible(
    "[fade-in-rubber-scroll-once]",
    "fade-in-rubber-scroll-once"
  );
}

window.addEventListener("scroll", function () {
  initiateClassWhenVisbleFunctions();
});
initiateClassWhenVisbleFunctions();

window.scrollTo({
  top: window.scrollY + 1,
  behavior: "smooth",
});

// let borders = document.querySelectorAll(".animated-border");

// const options = {
//   root: null,
//   rootMargin: "50px",
//   threshold: 0.5,
// };

// const borderObserver = new IntersectionObserver((entries, observer) => {
//   entries.forEach((entry) => {
//     if (entry.isIntersecting) {
//       if (entry.target.classList.contains("horizontally-animated")) {
//         entry.target.style.animation =
//           "animateHorizontalBorder 1s linear forwards";
//       } else if (entry.target.classList.contains("vertically-animated")) {
//         entry.target.style.animation =
//           "animateVerticalBorder 1s linear forwards";
//       }
//     }
//   });
// }, options);

// if (borders.length > 0) {
//   borders.forEach((border) => {
//     borderObserver.observe(border);
//   });
// }

const popSliderCards = document.querySelectorAll(
  ".pop-slider-container .swiper-slide"
);

const popSliderOptions = {
  root: null,
  rootMargin: "0px",
  threshold: 0.01,
};

const cardObserver = new IntersectionObserver((entries, observer) => {
  entries.forEach((entry, index) => {
    if (entry.isIntersecting) {
      entry.target.style.transitionDelay = `${index * 300}ms`;
      entry.target.style.marginLeft = "0px";
    }
  });
}, popSliderOptions);

if (window.innerWidth >= 990 && popSliderCards.length > 0) {
  popSliderCards.forEach((card) => {
    cardObserver.observe(card);
  });
}
